import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_32f48c25 from 'nuxt_plugin_plugin_32f48c25' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_82780c2c from 'nuxt_plugin_bootstrapvue_82780c2c' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_36d6d063 from 'nuxt_plugin_cookieuniversalnuxt_36d6d063' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_gtm_40657f5e from 'nuxt_plugin_gtm_40657f5e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginutils_a4e15640 from 'nuxt_plugin_pluginutils_a4e15640' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_3d0e2a2b from 'nuxt_plugin_pluginrouting_3d0e2a2b' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_dee02db8 from 'nuxt_plugin_pluginmain_dee02db8' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_fad7f28a from 'nuxt_plugin_axios_fad7f28a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vuescrollto_00d806ee from 'nuxt_plugin_vuescrollto_00d806ee' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_index_0c69654a from 'nuxt_plugin_index_0c69654a' // Source: ../src/plugins/index.js (mode: 'all')
import nuxt_plugin_fontawesomeplugins_4166c809 from 'nuxt_plugin_fontawesomeplugins_4166c809' // Source: ../src/plugins/font-awesome-plugins.js (mode: 'all')
import nuxt_plugin_utils_1ea7651c from 'nuxt_plugin_utils_1ea7651c' // Source: ../src/plugins/utils.js (mode: 'all')
import nuxt_plugin_apiplugin_3f01d23b from 'nuxt_plugin_apiplugin_3f01d23b' // Source: ../src/plugins/api-plugin.js (mode: 'all')
import nuxt_plugin_lodash_5d4c7b8c from 'nuxt_plugin_lodash_5d4c7b8c' // Source: ../src/plugins/lodash.js (mode: 'all')
import nuxt_plugin_rollbar_6da28fb7 from 'nuxt_plugin_rollbar_6da28fb7' // Source: ../src/plugins/rollbar.js (mode: 'all')
import nuxt_plugin_routeclient_29cb129e from 'nuxt_plugin_routeclient_29cb129e' // Source: ../src/plugins/route.client.js (mode: 'client')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../src/plugins/vuex-persist (mode: 'client')
import nuxt_plugin_playerplugin_6eed128d from 'nuxt_plugin_playerplugin_6eed128d' // Source: ../src/plugins/player.plugin.js (mode: 'client')
import nuxt_plugin_eventbusplugin_e2862266 from 'nuxt_plugin_eventbusplugin_e2862266' // Source: ../src/plugins/event-bus.plugin.js (mode: 'client')
import nuxt_plugin_wavesurferclient_1f313ad0 from 'nuxt_plugin_wavesurferclient_1f313ad0' // Source: ../src/plugins/wavesurfer.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"MotionElements","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"hid":"article:publisher","property":"article:publisher","content":"https:\u002F\u002Fwww.facebook.com\u002Fmotionelements"},{"hid":"msapplication-TileColor","name":"msapplication-TileColor","content":"#ffffff"},{"hid":"msapplication-config","name":"msapplication-config","content":"https:\u002F\u002Fstatic.moele.me\u002Fimg\u002Ffavicon\u002F220520\u002Fbrowserconfig.xml"},{"hid":"og:site_name","property":"og:site_name","content":"MotionElements"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:creator","name":"twitter:creator","content":"@MotionElements"},{"hid":"twitter:site","name":"twitter:site","content":"@MotionElements"},{"name":"theme-color","media":"(prefers-color-scheme: dark)","content":"#000000"},{"name":"theme-color","media":"(prefers-color-scheme: light)","content":"#ffffff"},{"name":"google-adsense-account","content":"ca-pub-1570933904955130"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"https:\u002F\u002Fstatic.moele.me\u002Fimg\u002Ffavicon\u002F220520\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"https:\u002F\u002Fstatic.moele.me\u002Fimg\u002Ffavicon\u002F220520\u002Ffavicon-16x16.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"https:\u002F\u002Fstatic.moele.me\u002Fimg\u002Ffavicon\u002F220520\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fstatic.moele.me\u002Fimg\u002Ffavicon\u002F220520\u002Ffavicon.ico"},{"rel":"manifest","href":"https:\u002F\u002Fstatic.moele.me\u002Fimg\u002Ffavicon\u002F220520\u002Fsite.webmanifest"},{"rel":"stylesheet","href":"https:\u002F\u002Fstatic.motionelements.com\u002Flib\u002Fflowplayer\u002F7.2.7\u002Fskin\u002Fskin.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.typekit.net\u002Fnwy7uwp.css"}],"script":[{"src":"https:\u002F\u002Fstatic.motionelements.com\u002Flib\u002Fflowplayer\u002F7.2.7\u002Fflowplayer.min.js?v=1543908999"},{"src":"https:\u002F\u002Fstatic.motionelements.com\u002Flib\u002Fjs\u002Fsoundmanager2\u002F2.97a.20170601\u002Fscript\u002Fsoundmanager2-nodebug-jsmin.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_32f48c25 === 'function') {
    await nuxt_plugin_plugin_32f48c25(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_82780c2c === 'function') {
    await nuxt_plugin_bootstrapvue_82780c2c(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_36d6d063 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_36d6d063(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_40657f5e === 'function') {
    await nuxt_plugin_gtm_40657f5e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_a4e15640 === 'function') {
    await nuxt_plugin_pluginutils_a4e15640(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3d0e2a2b === 'function') {
    await nuxt_plugin_pluginrouting_3d0e2a2b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_dee02db8 === 'function') {
    await nuxt_plugin_pluginmain_dee02db8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_fad7f28a === 'function') {
    await nuxt_plugin_axios_fad7f28a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_00d806ee === 'function') {
    await nuxt_plugin_vuescrollto_00d806ee(app.context, inject)
  }

  if (typeof nuxt_plugin_index_0c69654a === 'function') {
    await nuxt_plugin_index_0c69654a(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesomeplugins_4166c809 === 'function') {
    await nuxt_plugin_fontawesomeplugins_4166c809(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_1ea7651c === 'function') {
    await nuxt_plugin_utils_1ea7651c(app.context, inject)
  }

  if (typeof nuxt_plugin_apiplugin_3f01d23b === 'function') {
    await nuxt_plugin_apiplugin_3f01d23b(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_5d4c7b8c === 'function') {
    await nuxt_plugin_lodash_5d4c7b8c(app.context, inject)
  }

  if (typeof nuxt_plugin_rollbar_6da28fb7 === 'function') {
    await nuxt_plugin_rollbar_6da28fb7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routeclient_29cb129e === 'function') {
    await nuxt_plugin_routeclient_29cb129e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_playerplugin_6eed128d === 'function') {
    await nuxt_plugin_playerplugin_6eed128d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_eventbusplugin_e2862266 === 'function') {
    await nuxt_plugin_eventbusplugin_e2862266(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_wavesurferclient_1f313ad0 === 'function') {
    await nuxt_plugin_wavesurferclient_1f313ad0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
